import type { ProblemType } from './routeProblems'

export const PROBLEM_COLORS: Record<ProblemType, string> = {
  missingSegments: 'red',
  missingNodes: 'orange',
  oppositeDirectionSegments: 'grape',
  mismatchedEntranceNodes: 'yellow',
  mismatchedExitNodes: 'cyan',
  disconnectedSegments: 'pink',
}
